import {
  COVERAGE_CRITERIA_ALL,
  DEPENDENCY,
  DEMOGRAPHICS,
  HISTORY_TRANSLATION,
  INCOMPATIBILITY,
  INIT_POLICY_RULES,
  PLACE_OF_SERVICE,
  PXDX,
  tabOrder,
  UNLISTED_PA,
  MISSING_CC,
  PXDX_RFG_TAB,
  DEPENDENCY_RFG_TAB,
  DEMOGRAPHICS_RFG_TAB,
  HISTORY_TRANSLATION_RFG_TAB,
  INCOMPATIBILITY_RFG_TAB,
  PLACE_OF_SERVICE_RFG_TAB,
  UNLISTED_PA_RFG_TAB,
} from "../Constants/PolicyTranslationConstants";

import sortCCValues from "components/common/SharedHelperFunctions";
import dayjs from "dayjs";

export function getTabLabels() {
  const tempDynamicTabs = [];
  for (let table of tabOrder.keys()) {
    tempDynamicTabs.push({
      key: table,
      length: 0,
      display: table === PXDX ? true : false,
    });
  }
  return tempDynamicTabs;
}

export function getCoverageCriteriaList(policyRules) {
  const coverageCriteriaSet = new Set();
  let missingCCNumber = false;

  policyRules.forEach((rule) => {
    const CoverageCriteriaList = rule?.RuleFacts?.CoverageCriteriaList;
    if (CoverageCriteriaList) {
      const criteria = CoverageCriteriaList.split(/[,;]/)
        .map((cc) => cc.trim())
        .filter(Boolean);
      if (criteria.length === 0) {
        missingCCNumber = true;
      }
      criteria.forEach((cc) => coverageCriteriaSet.add(cc));
    } else {
      missingCCNumber = true;
    }
  });

  const coverageCriteriaList =
    Array.from(coverageCriteriaSet).sort(sortCCValues);
  if (missingCCNumber) {
    coverageCriteriaList.unshift(MISSING_CC);
  }

  return coverageCriteriaList;
}

export function getLobList(policyRules) {
  const lobSet = new Set();

  policyRules.forEach((rule) => {
    let LobConfigKey = rule?.RuleFacts?.LobConfigKey;

    if (Array.isArray(LobConfigKey)) {
      LobConfigKey.forEach((keyObj) => {
        const key =
          typeof keyObj === "object" && keyObj !== null
            ? keyObj.LobConfigKey
            : keyObj;
        if (key !== undefined && key !== null && `${key}`.trim() !== "") {
          lobSet.add(String(key).trim());
        }
      });
    } else if (
      LobConfigKey !== undefined &&
      LobConfigKey !== null &&
      `${LobConfigKey}`.trim() !== ""
    ) {
      lobSet.add(String(LobConfigKey).trim());
    }
  });

  // Use default array sort
  const lobList = Array.from(lobSet).sort();

  return lobList;
}

export function getAvailableProcedureCodes(policyRules) {
  let availableProcedureCodes = [];
  policyRules.forEach((policyRule) => {
    if (policyRule.RuleFacts?.ProcedureCode === undefined) {
      return;
    }
    if (!commonRuleCheck(policyRule)) {
      return;
    }
    let newProcedureCode = {
      code: policyRule.RuleFacts.ProcedureCode,
      codeDescription: policyRule.RuleFacts?.ProcedureCodeDescription,
      coverageCriteriaList: policyRule.RuleFacts?.CoverageCriteriaList,
      EditRule: policyRule.RuleHeader?.EditRule,
      DiagnosisListExpanded: policyRule.RuleFacts?.DiagnosisListExpanded,
      RuleEndDate: policyRule.RuleFacts?.RuleEndDate,
      PolicyNumber: policyRule.PolicyHeader?.PolicyNumber,
      ChangeControl: policyRule.RuleHeader?.ChangeControl,
      CodingClassification: policyRule.RuleFacts?.CodingClassification,
      DiagnosisListCondensed: policyRule.RuleFacts?.DiagnosisListCondensed,
      RuleVersion: policyRule.RuleHeader?.RuleVersion,
    };
    availableProcedureCodes.push(newProcedureCode);
  });

  availableProcedureCodes.sort((a, b) => a.code.localeCompare(b.code));
  return availableProcedureCodes;
}

export function filterRules(
  policyRulesList,
  selectedCC,
  selectedVariance,
  selectedUseCase,
  selectedLob,
  selectedHealthPlan,
  setDynamicTabs,
  setTabValue,
  tabValue
) {
  const policyRules = structuredClone(INIT_POLICY_RULES);

  // Map: { ProcedureCode_CC : [list of linked rules] } - this is used to group imported history rules
  // const linkedRuleGroups = {};

  // policyRulesList.forEach((rule) => {
  //   const ruleGroup = rule.RuleHeader?.RuleFlowGroup?.trim();
  //   if (
  //     !HISTORY_TRANSLATION_RFG_TAB.includes(ruleGroup) ||
  //     !commonRuleCheck(rule)
  //   )
  //     return; // ✅ Skip non-history rules

  //   const facts = rule.RuleFacts || {};
  //   const header = rule.RuleHeader || {};

  //   const procCode = facts.ProcedureCode?.trim() ?? "";
  //   const coverageCriteriaList =
  //     facts.CoverageCriteriaList?.split(/[,;]/)
  //       .map((coverageCriteria) => coverageCriteria.trim())
  //       .filter(Boolean) ?? [];
  //   const coverageCriteria = coverageCriteriaList.join(",");
  //   const approvedUnit = facts.ApprovedUnitCount?.toString().trim() ?? "";
  //   const allowedTimeframe = facts.AllowedTimeframe?.trim() ?? "";
  //   const dxLimitation = facts.DXLimitation?.trim() ?? "";
  //   const priority = header.Priority?.trim() ?? "";
  //   const endDate = facts.RuleEndDate?.trim() ?? "";
  //   const key = header.LinkedHistoryRuleKey
  //     ? header.LinkedHistoryRuleKey
  //     : `${procCode}_${coverageCriteria}_${approvedUnit}_${allowedTimeframe}_${dxLimitation}'`;

  //   console.log("key", key);
  //   if (!linkedRuleGroups[key]) linkedRuleGroups[key] = [];
  //   linkedRuleGroups[key].push(rule);
  // });

  // // Assign LinkedHistoryRuleKey to only grouped history rules
  // Object.entries(linkedRuleGroups).forEach(([key, rules]) => {
  //   rules.forEach((r) => {
  //     r.RuleHeader.LinkedHistoryRuleKey = key;
  //   });
  // });

  policyRulesList.forEach((policyRule) => {
    if (
      selectedCC !== COVERAGE_CRITERIA_ALL &&
      !policyRule.RuleFacts.CoverageCriteriaList.split(/[,;]/)
        .map((coverageCriteria) => coverageCriteria.trim())
        .includes(selectedCC) &&
      !(
        selectedCC === MISSING_CC &&
        policyRule.RuleFacts.CoverageCriteriaList.trim().length === 0
      )
    ) {
      return; // Skip if neither condition matches
    }

    if (
      selectedVariance !== "All" &&
      selectedHealthPlan !== "AHCS" &&
      !(
        ["NEW", "VARIANCE"].includes(policyRule.RuleHeader?.EditRule) ||
        policyRule.RuleHeader?.RuleVersion?.includes("-")
      )
    ) {
      return; // Skip if no conditions match
    }

    if (
      (selectedUseCase === "ToDo" &&
        policyRule.RuleHeader?.UseCase !== undefined &&
        policyRule.RuleHeader?.UseCase !== "") ||
      (selectedUseCase === "Complete" &&
        policyRule.RuleHeader?.UseCase !== "Complete")
    ) {
      return; // Skip if no conditions match
    }

    if (
      (!["All", "Global"].includes(selectedLob) &&
        (policyRule.RuleFacts?.LobConfigKey === undefined ||
          !(Array.isArray(policyRule.RuleFacts.LobConfigKey)
            ? policyRule.RuleFacts.LobConfigKey.some(
                (lob) => lob.LobConfigKey === selectedLob
              )
            : policyRule.RuleFacts.LobConfigKey === selectedLob))) ||
      (selectedLob === "Global" &&
        policyRule.RuleFacts?.LobConfigKey !== undefined &&
        policyRule.RuleFacts?.LobConfigKey !== "")
    ) {
      return; // Skip if no conditions match
    }

    if (!commonRuleCheck(policyRule)) {
      return false;
    }

    switch (true) {
      case isPxDxTranslationRule(policyRule):
        policyRule.id = policyRules[PXDX].length;
        policyRules[PXDX].push(policyRule);
        break;
      case isDependencyRule(policyRule):
        policyRule.id = policyRules[DEPENDENCY].length;
        policyRules[DEPENDENCY].push(policyRule);
        break;
      case isDemographicsRule(policyRule):
        policyRule.id = policyRules[DEMOGRAPHICS].length;
        policyRules[DEMOGRAPHICS].push(policyRule);
        break;
      case isHistoryTranslationRule(policyRule):
        policyRule.id = policyRules[HISTORY_TRANSLATION].length;
        policyRules[HISTORY_TRANSLATION].push(policyRule);
        break;
      case isIncompatibilityRule(policyRule):
        policyRule.id = policyRules[INCOMPATIBILITY].length;
        policyRules[INCOMPATIBILITY].push(policyRule);
        break;
      case isPlaceOfServiceRule(policyRule):
        policyRule.id = policyRules[PLACE_OF_SERVICE].length;
        policyRules[PLACE_OF_SERVICE].push(policyRule);
        break;
      case isUnlistedPaRule(policyRule):
        policyRule.id = policyRules[UNLISTED_PA].length;
        policyRules[UNLISTED_PA].push(policyRule);
        break;
    }
  });

  setDynamicTabs((prev) =>
    prev.map((tab) => {
      return {
        ...tab,
        length: policyRules[tab.key].length,
        display: policyRules[tab.key].length > 0 || tab.display,
      };
    })
  );

  return policyRules;
}

export function getAllRulesForValidation(policyRulesList) {
  const policyRules = structuredClone(INIT_POLICY_RULES);

  policyRulesList.forEach((policyRule) => {
    if (!commonRuleCheck(policyRule)) {
      return false;
    }

    switch (true) {
      case isPxDxTranslationRule(policyRule):
        policyRule.id = policyRules[PXDX].length;
        policyRules[PXDX].push(policyRule);
        break;
      case isDependencyRule(policyRule):
        policyRule.id = policyRules[DEPENDENCY].length;
        policyRules[DEPENDENCY].push(policyRule);
        break;
      case isDemographicsRule(policyRule):
        policyRule.id = policyRules[DEMOGRAPHICS].length;
        policyRules[DEMOGRAPHICS].push(policyRule);
        break;
      case isHistoryTranslationRule(policyRule):
        policyRule.id = policyRules[HISTORY_TRANSLATION].length;
        policyRules[HISTORY_TRANSLATION].push(policyRule);
        break;
      case isIncompatibilityRule(policyRule):
        policyRule.id = policyRules[INCOMPATIBILITY].length;
        policyRules[INCOMPATIBILITY].push(policyRule);
        break;
      case isPlaceOfServiceRule(policyRule):
        policyRule.id = policyRules[PLACE_OF_SERVICE].length;
        policyRules[PLACE_OF_SERVICE].push(policyRule);
        break;
      case isUnlistedPaRule(policyRule):
        policyRule.id = policyRules[UNLISTED_PA].length;
        policyRules[UNLISTED_PA].push(policyRule);
        break;
    }
  });

  return policyRules;
}

const commonRuleCheck = (policyRule) => {
  const ruleEndDate = policyRule.RuleFacts?.RuleEndDate;
  const editRule = policyRule.RuleHeader.EditRule || "";

  //If editRule is EDIT or VARIANCE and ruleEndDate is a valid date then return true.
  if (
    (editRule === "EDIT" || editRule === "VARIANCE") &&
    dayjs(ruleEndDate).isValid()
  ) {
    return true;
  } else {
    return (
      ruleEndDate === undefined || ruleEndDate === null || ruleEndDate === ""
    );
  }
};

export function isPxDxTranslationRule(policyRule) {
  return (
    PXDX_RFG_TAB.includes(policyRule.RuleHeader.RuleFlowGroup?.trim()) &&
    (policyRule.RuleFacts.DXLimitation === undefined ||
      policyRule.RuleFacts.DXLimitation?.trim() !==
        "CONDITION_DxCan'tHaveSecondary")
  );
}

export function isDependencyRule(policyRule) {
  return DEPENDENCY_RFG_TAB.includes(
    policyRule.RuleHeader.RuleFlowGroup?.trim()
  );
}

export function isDemographicsRule(policyRule) {
  return DEMOGRAPHICS_RFG_TAB.includes(
    policyRule.RuleHeader.RuleFlowGroup?.trim()
  );
}

export function isHistoryTranslationRule(policyRule) {
  const ruleGroup = policyRule.RuleHeader?.RuleFlowGroup?.trim();
  const priority = policyRule.RuleHeader?.Priority;

  return HISTORY_TRANSLATION_RFG_TAB.includes(ruleGroup) && priority !== "100";
}

export function isIncompatibilityRule(policyRule) {
  return INCOMPATIBILITY_RFG_TAB.includes(
    policyRule.RuleHeader.RuleFlowGroup?.trim()
  );
}

export function isPlaceOfServiceRule(policyRule) {
  return PLACE_OF_SERVICE_RFG_TAB.includes(
    policyRule.RuleHeader.RuleFlowGroup?.trim()
  );
}

export function isUnlistedPaRule(policyRule) {
  return UNLISTED_PA_RFG_TAB.includes(
    policyRule.RuleHeader.RuleFlowGroup?.trim()
  );
}
export function getLobName(LobConfigKey, policyData) {
  // Collect selected LOB ids (filter out null/undefined/empty)
  const selectedIds = Array.isArray(LobConfigKey)
    ? LobConfigKey.map((k) => k?.LobConfigKey).filter(
        (id) => id !== undefined && id !== null && id !== ""
      )
    : [];

  // If multiple or none are selected, return empty string
  if (selectedIds.length !== 1) return "";

  const targetId = Number(selectedIds[0]);
  if (Number.isNaN(targetId)) return "";

  const adoptionDecisions = Array.isArray(policyData?.lobAdoptionDecisionList)
    ? policyData.lobAdoptionDecisionList
    : [];

  const match = adoptionDecisions.find((d) => Number(d?.id) === targetId);
  return match?.lobDesc ?? "";
}

export function getLobNamesForFilter(LobConfigKey, policyData) {
  const adoptionDecisions = policyData?.lobAdoptionDecisionList;
  const lobConfig = adoptionDecisions?.find(
    (decision) => parseInt(decision.id) === parseInt(LobConfigKey)
  );
  return lobConfig ? lobConfig.lobDesc : "";
}

export function getAgeRange(ageRange, invalidAgeRange, DisplayAgeGenderRule) {
  let splitAgeRange = ageRange?.split(/[,]/);
  const invalidAgeRangeSplit = invalidAgeRange?.split(/[,]/);
  if (
    splitAgeRange == null ||
    splitAgeRange.length != 2 ||
    DisplayAgeGenderRule === "" ||
    DisplayAgeGenderRule === null
  ) {
    if (invalidAgeRangeSplit != null && invalidAgeRangeSplit.length === 2) {
      // If ageRange is invalid, use invalidAgeRange instead
      splitAgeRange = invalidAgeRangeSplit;
    } else splitAgeRange = ["", ""];
  }
  return splitAgeRange;
}

export const isVarianceRule = (rule) => {
  if (
    typeof rule.RuleHeader?.RuleVersion === "string" &&
    rule.RuleHeader.RuleVersion.includes("-")
  )
    return true;
  if (rule.RuleHeader.EditRule === "VARIANCE") return true;
  return false;
};
